// File: src/pages/ResetPasswordPage.jsx
import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, TextField, Button, Alert } from '@mui/material';
import { BASE_URL } from '../config';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ResetPasswordPage = () => {
  const [resetToken, setResetToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get token from URL parameters on component mount
  useEffect(() => {
    const tokenFromUrl = searchParams.get('token');
    console.log('🔍 DEBUG - Full URL:', window.location.href);
    console.log('🔍 DEBUG - Token from URL params:', tokenFromUrl);
    console.log('🔍 DEBUG - Token length from URL:', tokenFromUrl?.length);
    
    if (tokenFromUrl) {
      setResetToken(tokenFromUrl);
      console.log('🔍 DEBUG - Token set in state:', tokenFromUrl.substring(0, 50) + '...');
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      console.log('🔍 DEBUG - Sending reset request with token:', resetToken?.substring(0, 50) + '...');
      console.log('🔍 DEBUG - Token length:', resetToken?.length);
      
      const response = await fetch(`${BASE_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reset_token: resetToken, new_password: newPassword }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Password reset failed.');
      }
      const data = await response.json();
      setMessage(data.message || 'Password reset successful. You can now log in with your new password.');
      // Redirect to login after a brief delay
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Reset Password
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 4 }}
      >
        {!searchParams.get('token') && (
          <TextField
            label="Reset Token"
            required
            value={resetToken}
            onChange={(e) => setResetToken(e.target.value)}
            helperText="Enter the reset token from your email"
          />
        )}
        {searchParams.get('token') && (
          <Alert severity="info">
            Reset token loaded from URL. Please enter your new password below.
          </Alert>
        )}
        <TextField
          label="New Password"
          type="password"
          required
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          label="Confirm New Password"
          type="password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
        {message && (
          <Typography variant="body2" color="success.main">
            {message}
          </Typography>
        )}
        <Button variant="contained" color="primary" type="submit">
          Reset Password
        </Button>
        <Button variant="text" onClick={() => navigate('/login')}>
          Back to Login
        </Button>
      </Box>
    </Container>
  );
};

export default ResetPasswordPage;
